import { createContext } from "react";

export const WritingSheetPortalContext = createContext<string | undefined>(
	undefined,
);
